<div class="import">
    <div class="accordion">
        <app-expansion [meta]="metaExpansionEndpoint" [status]="status().endpoint">
            <app-endpoint [model]="model()" [formGroup]="formImport"></app-endpoint>
        </app-expansion>
        <app-expansion [meta]="metaExpansionCast" [status]="status().cast">
            <app-cast [model]="model()" [formGroup]="formImport"></app-cast>
        </app-expansion>
    </div>
</div>
